import React from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import MapIcon from '@material-ui/icons/Map';
import { Location } from './locationTypes';
import SharpImage from "../utils/sharpImage"
import { LocationListStyles } from "./LocationList.styles";

interface Props {
    locations: Location[];
    showOnMap?: (location: Location) => void;
    selected?: Location;
};

export default function LocationList({ locations, showOnMap, selected }: Props) {
    const tryShowOnMap = (location) => {
        if (showOnMap && typeof (showOnMap) === "function")
            showOnMap(location)
    }
    const classes = LocationListStyles();

    return (
        <List className={classes.locationList}>
            {locations.map(location => {
                //const add = `${location.address} ${location.city} ${location.state} ${location.postcode}`;
                return (
                    <ListItem key={location.id} className={`${classes.locationListItem} ${selected && selected.id == location.id ? classes.locationListSelected : ""}`} onClick={e => tryShowOnMap(location)}>
                        <ListItemAvatar>
                            <Avatar>
                                {location.logo && location.logo.childImageSharp && location.logo.childImageSharp.gatsbyImageData ?
                                    <>
                                        <SharpImage file={location.logo} title={location.name} altText={location.name} style={{ margin: "auto" }} imgStyle={{ width: "40px", height: "40px" }} />
                                    </>
                                    : null}

                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText primary={
                                <Typography
                                    component="span"
                                    variant="body2"
                                    className={classes.locationListAddress}
                                    color="textSecondary"
                                >
                                    {location.name}
                                </Typography>
                            }

                                secondary={
                            <>
                                <Typography
                                    component="span"
                                    variant="body2"
                                    className={classes.locationListAddress}
                                    color="textSecondary"
                                >
                                    {location.city}
                                </Typography>
                            </>
                        } />
                        <ListItemSecondaryAction className={classes.locationListDistanceContainer}>
                            <Typography
                                component="span"
                                variant="h6"
                                className={classes.locationListAddress}
                                color="textPrimary"
                            >
                                {location.distance && location.distance > 0 && (<span className={classes.locationListDistance}>{location.distance}km</span>)}
                            </Typography>
                        </ListItemSecondaryAction>
                    </ListItem>
                )
            })}
        </List>
    );
}